import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.704 1.55C6.38.956 5.778.5 4.98.5c-.704 0-1.245.482-1.494.965C3.236.982 2.695.5 1.992.5.763.5 0 1.578 0 2.582c0 .98.791 1.93 1.62 2.653l.1.085c.622.528 1.249.923 1.562 1.103.12.07.195.106.204.106.052 0 2.442-1.328 3.234-2.951a2.238 2.238 0 0 0 .25-1.09 2.193 2.193 0 0 0-.266-.938Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1.033 7.332a6.665 6.665 0 0 0-.037.705c0 3.607 2.898 6.531 6.474 6.531 1.663 0 3.18-.632 4.326-1.672l2.873 2.604L16 14.005l-2.943-2.668a6.547 6.547 0 0 0 .886-3.3c0-3.13-2.18-5.744-5.091-6.383.074.312.111.625.111.928 0 .404-.062.784-.165 1.135a4.52 4.52 0 0 1 3.153 4.32c0 2.497-2.006 4.522-4.481 4.522-2.327 0-4.24-1.79-4.46-4.078l-.021-.005h-.002a2.018 2.018 0 0 1-.447-.174 5.188 5.188 0 0 1-.194-.105 13.634 13.634 0 0 1-1.313-.865Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconProductSaveSearch16 = createIcon(IconComponent);